import React, { useState } from "react";

import { Box, Typography, useTheme } from "@mui/material";
import { useFieldArray } from "react-hook-form";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import CookingMethodInstruction from "./CookingMethodInstruction";
import { RecipeFormValues } from "./RecipeForm";

const useStyles = makeStyles()({
  heading1: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 1,
    color: colors.dark,
  },
});

const CookingMethodForm: React.FC = () => {
  const theme = useTheme();
  const { classes } = useStyles();
  const { fields, move, append, remove } = useFieldArray<RecipeFormValues>({
    name: "instructions",
  });
  const [newText, setNewText] = useState("");

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      flex={1}
      p={theme.spacing(1, 6, 6)}
    >
      <Box mb={6}>
        <Typography className={classes.heading1}>
          Cooking Instructions
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" alignItems="stretch">
        {fields.map((instruction, index) => (
          <CookingMethodInstruction.Edit
            // Using id as `key` prop, since moving will change index.
            key={instruction.id}
            index={index}
            // Don't use `move` from FieldArray, its buggy, reporting
            // nonexistent errors. We'll do it ourselves.
            onMove={(fromIndex, toIndex) => move(fromIndex, toIndex)}
            onRemove={remove}
          />
        ))}
        <CookingMethodInstruction.Add
          text={newText}
          onChange={setNewText}
          onAdd={() => append({ text: newText })}
        />
      </Box>
    </Box>
  );
};

export default CookingMethodForm;
